import {Currencies} from '../types';

export const getCurrencyAndType = (currency: string | null, type: 0 | 1 | boolean | null): string => (
	`${currency ?? Currencies.EUR} ${type === 0 || type === false ? '(ціна за тону)' : '(повна сума)'}`
);